import React from 'react';
import { useStaticQuery, Link as GatsbyLink, graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, IconProps, Icon } from '@printdeal/ui-library';
import HelpCenterSearch from './HelpCenterSearch';
import useSystemPages from '../../hooks/useSystemPages';
import HelpWidget from '../widgets/HelpWidget';

interface HelpCenterCategoriesProps {
  supportArticleCategory?: {
    path: string;
    title: string;
  };
}

interface HelpCenterCategoriesNode {
  node: {
    title: string;
    id: string;
    path: string;
    icon?: IconProps['icon'];
    node_locale: string;
  }
}

const HelpCenterCategories = ({ supportArticleCategory = undefined }: HelpCenterCategoriesProps) => {
  const intl = useIntl();
  const { categories } = useStaticQuery<{ categories: { edges: HelpCenterCategoriesNode[] } }>(graphql`
    query {
      categories: allContentfulSupportArticleCategory(
        sort: { displayOrder: ASC }
      ) {
        edges {
          node {
            id
            title
            icon
            path
            node_locale
          }
        }
      }
    }
  `);
  const [helpCenterIndex] = useSystemPages('helpCenterIndex');
  const defaultIcon = 'info';

  return (
    <>
      <Link as={GatsbyLink} iconBefore="chevron-left" to={helpCenterIndex.path} variant="secondary">
        <FormattedMessage id="helpcenter.category.backto" defaultMessage="Back to helpcenter" />
      </Link>
      <div className="pd-relative pd-my-6">
        <HelpCenterSearch styling="alt" position="sidebar" />
      </div>
      {categories?.edges?.filter((category) => category.node.node_locale === intl.locale)
        .map(({ node }) => {
          const active = supportArticleCategory?.title === node.title;
          return (
            <Link
              key={node.id}
              as={GatsbyLink}
              iconBefore={node.icon ? node.icon : defaultIcon}
              variant={active ? 'primary' : 'secondary'}
              iconAfter={active ? undefined : <Icon icon="chevron-right" className="pd-ml-auto" />}
              to={node.path}
              className="pd-flex pd-py-4"
            >
              {node.title}
            </Link>
          );
        })}
      <hr className="pd-mb-11 pd-mt-4" />
      <HelpWidget withImage={false} />
    </>
  );
};

export default HelpCenterCategories;
